import { Heading } from "./Primitives";

export const COMMAND_LIST = [
  ["help", "list all available commands"],
  ["about / whoami", "who I am"],
  ["stack", "languages, frameworks, tools"],
  ["experience", "work history"],
  ["projects", "quick view of shipped / completed work"],
  ["ongoing", "quick view of work in progress"],
  ["contact", "ways to reach me"],
  ["cd <dir>", "navigate into projects/, ongoing/, or ~ (root)"],
  ["ls", "list contents of the current directory"],
  ["cat <file>", "read a file — e.g. cat about.txt, cat flowbase"],
  ["pwd", "print current directory"],
  ["clear", "clear the terminal"],
];

export default function HelpOutput() {
  return (
    <div>
      <Heading>available commands</Heading>
      <div className="space-y-0.5">
        {COMMAND_LIST.map(([cmd, desc]) => (
          <div key={cmd} className="flex gap-3">
            <span className="text-emerald-400 w-36 shrink-0">{cmd}</span>
            <span className="text-neutral-400">{desc}</span>
          </div>
        ))}
      </div>
      <div className="mt-2 text-neutral-600 text-[12px]">
        try: <span className="text-emerald-400">cd projects</span> → <span className="text-emerald-400">ls</span> → <span className="text-emerald-400">cat flowbase</span>
      </div>
    </div>
  );
}